export default {
  headers: [
    {
      id: 'miniHeader',
      logo: {
        alt: 'logo',
        src: '',
      },
      breakpoint: 1200,
      desktopMenu: {
        type: 'split', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: false,
          reverseOrder: false,
          containerClassName: '',
          imageClassName: '',
        },
        headerClassName: 'on-kaprije-miniHeader',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: 'on-kaprije-miniHeader-item',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [
          {
            id: '0headerHome',
            content: 'Free Home Value Report',
            url: '/',
          },
          {
            id: '0headerNumb',
            content: '904-476-5539',
            url: '/',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: false,
          containerClassName: '',
          imageClassName: '',
        },
        type: 'mobile-content', // mobile-default, mobile-reversed, mobile-center
        menuOpener: {
          className: '',
          content: 'Open',
          hide: true,
        },
        headerClassName: 'on-kaprije-miniHeader-mobile-content',
        headerClassNameOverride: '',
        mobileMenuClassName: '',
        itemClassName: '',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [
          {
            id: 'home-value-item',
            content: 'Free Home Value Report\n',
            url: 'https://www.welchteam.com/home-value-report-2/',
          },
          {
            id: 'phone-item',
            content: '904-476-5539',
            url: 'https://www.welchteam.com/contact-us/',
          },
        ],
        items: [],
      },
    },
    {
      id: 'mainHeader',
      logo: {
        alt: 'logo',
        src: 'https://si-homelight.s3.amazonaws.com/sites/kaprije/logo.png',
        url: 'https://www.welchteam.com/',
      },
      breakpoint: 1200,
      desktopMenu: {
        type: 'center', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: true,
          reverseOrder: false,
          containerClassName: '',
          imageClassName: 'on-kaprije-mainHeader-logo',
        },
        headerClassName: 'on-kaprije-mainHeader',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: '',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [],
      },
      mobileMenu: {
        logo: {
          show: false,
          containerClassName: '',
          imageClassName: '',
        },
        type: 'mobile-reversed', // mobile-default, mobile-center
        menuOpener: {
          type: 'hamburger',
          className: '',
          hide: false,
          reverse: true,
        },
        headerClassName: 'on-kaprije-mobile-mainHeader',
        headerSectionsClassName: 'on-kaprije-header-mobile-sections',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        mobileMenuClassName: 'on-kaprije-header-mobile-menu',
        itemClassName: 'on-kaprije-header-mobile-item',
        menuClassName: 'on-kaprije-header-mobile-folder',
        menuLabelActiveClassName: 'on-kaprije-header-mobile-folder-active',
        menuItemClassName: 'on-kaprije-header-mobile-menu-item',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [
          {
            id: 'on-kaprije-mobile-header-logo',
            className: 'on-kaprije-header-mobile-logo',
            image: {
              alt: 'logo',
              src: 'https://si-homelight.s3.amazonaws.com/sites/kaprije/logo.png',
            },
          },
        ],
        items: [
          {
            id: 'logo-item',
            image: {
              alt: 'logo',
              src: 'https://si-homelight.s3.amazonaws.com/sites/kaprije/logo.png',
            },
          },
          {
            id: 'item-services',
            content: 'REAL ESTATE SERVICES',
            menuItems: [
              {
                id: 'item-services-residential',
                content: 'RESIDENTIAL',
                url: 'https://www.welchteam.com/real-estate-services/residential/',
              },
              {
                id: 'item-services-commerical',
                content: 'COMMERICAL',
                url: 'https://www.welchteam.com/real-estate-services/commercial/',
              },
              {
                id: 'item-services-luxury',
                content: 'LUXURY REAL ESTATE',
                url: 'https://www.welchteam.com/real-estate-services/luxury-real-estate/',
              },
              {
                id: 'item-services-mortgage',
                content: 'MORTGAGE',
                url: 'https://www.welchteam.com/real-estate-services/mortgage/',
              },
              {
                id: 'item-services-military',
                content: 'MILITARY RELOCATION',
                url: 'https://www.welchteam.com/real-estate-services/military-relocation/',
              },
              {
                id: 'item-services-ibuyers',
                content: 'IBUYERS',
                url: 'https://www.welchteam.com/real-estate-services/ibuyers/',
              },
              {
                id: 'item-services-coaching',
                content: 'COACHING TO CLOSE',
                url: 'https://coachingtoclose.com/',
              },
              {
                id: 'item-services-cash-offer',
                content: 'BECOME A CASH BUYER',
                url: 'https://cash-offer-kaprije.netlify.app',
              },
              {
                id: 'item-services-trade-in',
                content: 'BUY BEFORE YOU SELL',
                url: 'https://trade-in-kaprije.netlify.app',
              },
            ],
          },
          {
            id: 'item-find',
            content: 'FIND YOUR REAL ESTATE',
            menuItems: [
              {
                id: 'item-find-listings',
                content: 'WELCH LISTINGS',
                url: 'https://www.welchteam.com/find-your-real-estate/listings/',
              },
              {
                id: 'item-find-search-homes',
                content: 'SEARCH HOMES FOR SALE',
                url: 'https://welchteam.idxbroker.com/idx/search/basic',
              },
              {
                id: 'item-find-commercial',
                content: 'COMMERICAL PROPERTIES FOR SALE',
                url: 'https://welchteam.idxbroker.com/i/commercial',
              },
              {
                id: 'item-find-map-search',
                content: 'MAP SEARCH',
                url: 'https://welchteam.idxbroker.com/idx/map/mapsearch',
              },
              {
                id: 'item-find-open-houses',
                content: 'OPEN HOUSES',
                url: 'https://www.welchteam.com/find-your-real-estate/open-houses/',
              },
            ],
          },
          {
            id: 'item-areas',
            content: 'AREAS WE SERVE',
            url: 'https://www.welchteam.com/areas-we-serve/',
          },
          {
            id: 'item-about',
            content: 'ABOUT',
            menuItems: [
              {
                id: 'item-about-agents',
                content: 'AGENTS',
                url: 'https://www.welchteam.com/about/agents/',
              },
              {
                id: 'item-about-support-team',
                content: 'SUPPORT TEAM',
                url: 'https://www.welchteam.com/about/support-team/',
              },
              {
                id: 'item-about-careers',
                content: 'CAREERS',
                url: 'https://www.welchteam.com/about/careers/',
              },
              {
                id: 'item-about-testiomnials',
                content: 'TESTIMONIALS',
                url: 'https://www.welchteam.com/about/testimonials/',
              },
              {
                id: 'item-about-ask-agent',
                content: 'ASK THE AGENT',
                url: 'https://www.welchteam.com/about/ask-the-agent/',
              },
              {
                id: 'item-about-knock',
                content: 'KNOCK CERTIFIED AGENT',
                url: 'https://www.welchteam.com/about/knock-home-swap/',
              },
            ],
          },
          {
            id: 'item-res',
            content: 'RESOURCES',
            menuItems: [
              {
                id: 'item-res-guide',
                content: 'BUYERS GUIDE',
                url: 'https://www.welchteam.com/about/buyers-guide/',
              },
              {
                id: 'item-res-vendors',
                content: 'VENDOR LIST',
                url: 'https://www.welchteam.com/about/vendor-list/',
              },
              {
                id: 'item-res-blog',
                content: 'BLOG',
                url: 'https://www.welchteam.com/blog/',
              },
              {
                id: 'item-res-faq',
                content: 'FAQ',
                url: 'https://www.welchteam.com/blog/faqs/',
              },
            ],
          },
          {
            id: 'item-contact',
            content: 'CONTACT US',
            url: 'https://www.welchteam.com/contact-us/',
          },
        ],
      },
    },
    {
      id: 'menuHeader',
      logo: {
        alt: 'logo',
        src: '',
      },
      breakpoint: 1200,
      desktopMenu: {
        type: 'single', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: false,
          reverseOrder: false,
          containerClassName: '',
          imageClassName: '',
        },
        headerClassName: 'on-kaprije-menuHeader',
        headerSectionsClassName: 'on-kaprije-menuHeader-sections',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: 'on-kaprije-menuHeader-item',
        menuClassName: 'on-kaprije-menuHeader-menu',
        menuLabelActiveClassName: '',
        menuItemClassName: 'on-kaprije-menuHeader-menu-item',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [
          {
            id: 'item-services',
            content: 'REAL ESTATE SERVICES',
            url: 'https://www.welchteam.com/real-estate-services/',
            menuItems: [
              {
                id: 'item-services-residential',
                content: 'RESIDENTIAL',
                url: 'https://www.welchteam.com/real-estate-services/residential/',
              },
              {
                id: 'item-services-commerical',
                content: 'COMMERICAL',
                url: 'https://www.welchteam.com/real-estate-services/commercial/',
              },
              {
                id: 'item-services-luxury',
                content: 'LUXURY REAL ESTATE',
                url: 'https://www.welchteam.com/real-estate-services/luxury-real-estate/',
              },
              {
                id: 'item-services-mortgage',
                content: 'MORTGAGE',
                url: 'https://www.welchteam.com/real-estate-services/mortgage/',
              },
              {
                id: 'item-services-military',
                content: 'MILITARY RELOCATION',
                url: 'https://www.welchteam.com/real-estate-services/military-relocation/',
              },
              {
                id: 'item-services-ibuyers',
                content: 'IBUYERS',
                url: 'https://www.welchteam.com/real-estate-services/ibuyers/',
              },
              {
                id: 'item-services-coaching',
                content: 'COACHING TO CLOSE',
                url: 'https://coachingtoclose.com/',
              },
              {
                id: 'item-services-cash-offer',
                content: 'BECOME A CASH BUYER',
                url: 'https://cash-offer-kaprije.netlify.app',
              },
              {
                id: 'item-services-trade-in',
                content: 'BUY BEFORE YOU SELL',
                url: 'https://trade-in-kaprije.netlify.app',
              },
            ],
          },
          {
            id: 'item-find',
            content: 'FIND YOUR REAL ESTATE',
            url: 'https://www.welchteam.com/find-your-real-estate/',
            menuItems: [
              {
                id: 'item-find-listings',
                content: 'WELCH LISTINGS',
                url: 'https://www.welchteam.com/find-your-real-estate/listings/',
              },
              {
                id: 'item-find-search-homes',
                content: 'SEARCH HOMES FOR SALE',
                url: 'https://welchteam.idxbroker.com/idx/search/basic',
              },
              {
                id: 'item-find-commercial',
                content: 'COMMERICAL PROPERTIES FOR SALE',
                url: 'https://welchteam.idxbroker.com/i/commercial',
              },
              {
                id: 'item-find-map-search',
                content: 'MAP SEARCH',
                url: 'https://welchteam.idxbroker.com/idx/map/mapsearch',
              },
              {
                id: 'item-find-open-houses',
                content: 'OPEN HOUSES',
                url: 'https://www.welchteam.com/find-your-real-estate/open-houses/',
              },
            ],
          },
          {
            id: 'item-areas',
            content: 'AREAS WE SERVE',
            url: 'https://www.welchteam.com/areas-we-serve/',
          },
          {
            id: 'item-about',
            content: 'ABOUT',
            url: 'https://www.welchteam.com/about/',
            menuItems: [
              {
                id: 'item-about-agents',
                content: 'AGENTS',
                url: 'https://www.welchteam.com/about/agents/',
              },
              {
                id: 'item-about-support-team',
                content: 'SUPPORT TEAM',
                url: 'https://www.welchteam.com/about/support-team/',
              },
              {
                id: 'item-about-careers',
                content: 'CAREERS',
                url: 'https://www.welchteam.com/about/careers/',
              },
              {
                id: 'item-about-testiomnials',
                content: 'TESTIMONIALS',
                url: 'https://www.welchteam.com/about/testimonials/',
              },
              {
                id: 'item-about-ask-agent',
                content: 'ASK THE AGENT',
                url: 'https://www.welchteam.com/about/ask-the-agent/',
              },
              {
                id: 'item-about-knock',
                content: 'KNOCK CERTIFIED AGENT',
                url: 'https://www.welchteam.com/about/knock-home-swap/',
              },
            ],
          },
          {
            id: 'item-res',
            content: 'RESOURCES',
            url: 'https://www.welchteam.com/blog/',
            menuItems: [
              {
                id: 'item-res-guide',
                content: 'BUYERS GUIDE',
                url: 'https://www.welchteam.com/about/buyers-guide/',
              },
              {
                id: 'item-res-vendors',
                content: 'VENDOR LIST',
                url: 'https://www.welchteam.com/about/vendor-list/',
              },
              {
                id: 'item-res-blog',
                content: 'BLOG',
                url: 'https://www.welchteam.com/blog/',
              },
              {
                id: 'item-res-faq',
                content: 'FAQ',
                url: 'https://www.welchteam.com/blog/faqs/',
              },
            ],
          },
          {
            id: 'item-contact',
            content: 'CONTACT US',
            url: 'https://www.welchteam.com/contact-us/',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: false,
          containerClassName: '',
          imageClassName: '',
        },
        type: 'mobile-content', // mobile-default, mobile-reversed, mobile-center
        menuOpener: {
          className: '',
          content: 'Open',
          hide: true,
        },
        headerClassName: '',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        mobileMenuClassName: '',
        itemClassName: '',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [],
        items: [],
      },
    },
  ],
  footers: [
    {
      id: 0,
      display: true,
      sectionClassName: 'on-kaprije-footer-section-container',
      className: 'on-kaprije-footer-section-first d-sm-block d-md-block d-lg-flex d-xl-flex between-xl between-lg',
      columns: [
        {
          id: 0,
          className: 'col-xl-4 col-lg-4 p-3',
          style: {},
          items: [
            {
              id: 0,
              type: 'heading',
              elementType: 'a',
              className: 'on-kaprije-footer-phone d-block',
              data: '904-476-5539',
              url: 'tel:904-476-5539',
            },
            {
              id: 1,
              type: 'heading',
              className: 'on-kaprije-footer-contact-us align-center d-sm-inline-block',
              style: {},
              data: 'CONTACT US',
              url: 'https://www.welchteam.com/contact-us/',
            },
          ],
        },
        {
          id: 1,
          className: 'col-xl-4 col-lg-4 p-3',
          style: {},
          items: [
            {
              id: 0,
              type: 'heading',
              elementType: 'h1',
              className: 'on-kaprije-footer-heading',
              style: { color: '#b00400' },
              data: 'Find Us',
            },
            {
              id: 1,
              type: 'menu',
              className: 'on-kaprije-footer-menu',
              itemClassName: 'mb-0',
              style: {},
              items: [
                {
                  id: 0,
                  data: '301 Kingsley Lake Drive #502',
                },
                {
                  id: 1,
                  data: 'St. Augustine, FL 32092',
                },
                {
                  id: 2,
                  data: 'Get Directions',
                  url: 'https://goo.gl/maps/9ZqAiPJ1CJZfN98LA',
                },
              ],
            },
          ],
        },
        {
          id: 2,
          className: 'col-xl-4 col-lg-4 p-3',
          style: {},
          items: [
            {
              id: 0,
              type: 'menu',
              className: 'on-kaprije-footer-menu-pages',
              style: { display: 'grid' },
              items: [
                {
                  id: 0,
                  className: 'on-kaprije-footer-menu-home',
                  style: { color: '#b00400' },
                  data: 'Home',
                  url: 'https://www.welchteam.com/',
                },
                {
                  id: 1,
                  data: 'Real Estate Services',
                  url: 'https://www.welchteam.com/real-estate-services/',
                },
                {
                  id: 2,
                  data: 'Find Your Real Estate',
                  url: 'https://www.welchteam.com/find-your-real-estate/',
                },
                {
                  id: 3,
                  data: 'Areas We Serve',
                  url: 'https://www.welchteam.com/areas-we-serve/',
                },
                {
                  id: 4,
                  data: 'About',
                  url: 'https://www.welchteam.com/about/',
                },
                {
                  id: 5,
                  data: 'Blog',
                  url: 'https://www.welchteam.com/blog/',
                },
                {
                  id: 6,
                  data: 'Real Estate Services in Northeast Florida',
                  url: 'https://www.welchteam.com/contact-us/',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 1,
      display: true,
      sectionClassName: 'on-kaprije-footer-section-container',
      className: 'on-kaprije-footer-section-socials',
      columns: [
        {
          id: 0,
          className: 'd-block',
          style: {},
          items: [
            {
              id: 0,
              type: 'socialIcons',
              itemClassName: 'on-kaprije-footer-socials',
              style: {},
              items: [
                {
                  id: 0,
                  url: 'https://www.facebook.com/welchteam/',
                  iconTypeClassName: 'fab',
                  iconClassName: 'facebook-square',
                },
                {
                  id: 1,
                  url: 'https://twitter.com/welchteam_kw',
                  iconTypeClassName: 'fab',
                  iconClassName: 'twitter',
                },
                {
                  id: 2,
                  url: 'https://www.instagram.com/welchteam/?hl=en',
                  iconTypeClassName: 'fab',
                  iconClassName: 'instagram',
                },
                {
                  id: 3,
                  url: 'https://www.youtube.com/channel/UCfwSc57BJyPlm3OQfOLDjGQ',
                  iconTypeClassName: 'fab',
                  iconClassName: 'youtube',
                },
                {
                  id: 4,
                  url: 'https://www.yelp.com/biz/welch-team-keller-williams-realty-st-augustine',
                  iconTypeClassName: 'fab',
                  iconClassName: 'yelp',
                },
                {
                  id: 5,
                  url: 'https://www.linkedin.com/in/welchteam',
                  iconTypeClassName: 'fab',
                  iconClassName: 'linkedin',
                },
                {
                  id: 2,
                  url: 'https://www.pinterest.com/welchteam/_created/',
                  iconTypeClassName: 'fab',
                  iconClassName: 'pinterest',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      display: true,
      sectionClassName: 'on-kaprije-footer-section-container-last',
      className: 'on-kaprije-footer-section-last center-sm',
      columns: [
        {
          id: 0,
          className: 'on-kaprije-footer-last-items d-xl-flex d-lg-flex d-md-block d-sm-block',
          style: {},
          items: [
            {
              id: 0,
              type: 'heading',
              elementType: 'p',
              className: 'pe-3',
              style: {},
              data: '© 2022 Welch Team. All Rights Reserved. ',
            },
            {
              id: 1,
              type: 'menu',
              className: 'on-kaprije-privacy',
              style: {},
              items: [
                {
                  id: 0,
                  className: 'pe-1 ps-1',
                  data: 'Privacy Policy ',
                  url: 'https://www.welchteam.com/privacy-policy/',
                },
                {
                  id: 1,
                  className: 'pe-1 ps-1',
                  data: 'Sitemap',
                  url: 'https://www.welchteam.com/sitemap/',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  substitute: {},
  replace: {
    'tradeIn.hero.backgroundImage.style': 'heroBackgroundStyle',
    'cashOffer.hero.backgroundImage.style': 'heroBackgroundStyle',
  },
  siteData: {
    heroBackgroundStyle: {
      objectPosition: 'center top',
    },
    agency: 'Welch Team',
    agentName: 'The Welch Team',
    agentDescription: 'Top agents in Northeast Florida',
    agentAvatar: 'https://si-homelight.s3.amazonaws.com/sites/kaprije/agent.png',
    heroBackground: 'https://si-homelight.s3.amazonaws.com/sites/kaprije/hero-bg.jpg',
    expressFee: '1.5%',
  },
};
